// Vouchers Store
import { i18n } from '@/translations/i18n'
import {trackScreenView} from '../../helper';

const state = {
  vouchers: [],
  pending: false,
  error: null,
  success: null,
  cartVouchers: [],
  isVoucherModalVisible: false,
}

const getters = {
  isPending: ({ pending }) => pending,
}

const actions = {
  // getVouchers({ commit }) {
  //   return new Promise(resolve => {
  //     commit('SET_PENDING')
  //     commit('REMOVE_ERROR')
  //     this.http.get('get_vouchers_test').then(({ data }) => {
  //       if (data.type === 1) {
  //         commit('SET_VOUCHERS', data.vouchers)
  //       }
  //       commit('SET_PENDING')
  //       resolve()
  //     })
  //   })
  // },
  addVoucher({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      commit('REMOVE_ERROR')
      this.api.items.createItem('carts.mine.vouchers', {
        voucher_code: payload,
      })
        .then(({ data }) => {
          if (data.type === 1) {
            commit('ADD_VOUCHER', data)
          } else {
            commit('SET_ERROR', data)
          }
          commit('SET_PENDING')
          resolve(data)
        })
    })
  },
  removeVoucher({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      commit('REMOVE_ERROR')
      this.api.items.deleteItem(`carts.mine.vouchers.${payload.id}`).then(({ data }) => {
        commit('REMOVE_VOUCHER', payload)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getCartVouchers({ commit }, source = 'cart') {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      // Do not clear error here: refetch after add/remove failure would wipe the error before the UI shows it. Error is cleared when user retries (add/remove).
      this.api.items
        .getItem('/vouchers?source=cart')
        .then(({ data }) => {
          commit('SET_CART_VOUCHERS', Array.isArray(data?.results) ? data?.results
            : [])
          commit('SET_PENDING')
          resolve(data)
        })
        .catch(error => {
          commit('SET_PENDING')
          commit('SET_ERROR', error)
          reject(error)
        })
    })
  },
  openVoucherModal({ commit }) {
    commit('SET_VOUCHER_MODAL_VISIBLE', true)
  },
  closeVoucherModal({ commit }) {
    commit('SET_VOUCHER_MODAL_VISIBLE', false)
  },
  addCartVouchers({ commit, dispatch }, payload) {
    const voucherCode = Array.isArray(payload) ? payload : [payload]
    return new Promise(async (resolve, reject) => {
      commit('SET_PENDING')
      commit('REMOVE_ERROR')
      commit('REMOVE_SUCCESS')
      let tracking_data = null
      try {
        const { data } = await this.api.items.createItem('/cart/vouchers', { voucher_code: voucherCode })

        commit('SET_PENDING')
        if (data?.tracking_data) {
          tracking_data = data.tracking_data
        }

        if (data?.status !== 200) {
          commit('SET_ERROR', { msg: data?.errors?.join?.(' ') || data?.message || 'Bad Request' })
          reject(data)
          return
        }

        const successMsg = i18n.global?.t?.('my_account.the_club.voucher_changes_count') ?? 'Voucher Redeemed'
        commit('SET_SUCCESS', { msg: successMsg })

        resolve(data)
      } catch (error) {
        commit('SET_PENDING')
        if (error?.data?.tracking_data) {
          tracking_data = error.data.tracking_data
        }

        const errData = error?.data || error
        const msg = errData?.errors?.join?.(' ') || errData?.message || errData?.msg || 'Bad Request'
        commit('SET_ERROR', { msg })

        reject(error)
      } finally {
        try {
          await dispatch('getCartVouchers')
          await dispatch('checkout/getCheckout', null, { root: true })
        } catch (error) {
          reject(error)
        } finally {
          if (tracking_data) {
            if (Array.isArray(tracking_data)) {
              tracking_data = tracking_data.pop()
            }
            tracking_data.promotion_coupon_entered = Array.isArray(voucherCode) ? voucherCode.pop() : voucherCode
            trackScreenView('CartAddVoucher', {
              tracking: tracking_data,
              type: 'event',
            })
          }
        }
      }
    })
  },
  removeCartVouchers({ commit, dispatch }, payload) {
    const voucherCode = Array.isArray(payload) ? payload : [payload]
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      commit('REMOVE_ERROR')
      commit('REMOVE_SUCCESS')
      this.api.items
        .deleteItem('/cart/vouchers', { codes: voucherCode })
        .then(({ data }) => {
          commit('SET_PENDING')
          if (data?.status !== 200) {
            commit('SET_ERROR', { msg: data?.errors?.join?.(' ') || data?.message || 'Bad Request' })
            reject(data)
            return
          }
          const successMsg = i18n.global?.t?.('my_account.the_club.voucher_changes_applied') ?? 'Voucher changes applied.'
          commit('SET_SUCCESS', { msg: successMsg })
          dispatch('getCartVouchers')
            .then(() => dispatch('checkout/getCheckout', null, { root: true }))
            .then(() => resolve(data))
            .catch(reject)
        })
        .catch(error => {
          commit('SET_PENDING')
          const errData = error?.data || error
          const msg = errData?.errors?.join?.(' ') || errData?.message || errData?.msg || 'Bad Request'
          commit('SET_ERROR', { msg })
          reject(error)
          dispatch('getCartVouchers')
            .then(() => dispatch('checkout/getCheckout', null, { root: true }))
            .then(() => resolve(data))
            .catch(reject)
        })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_VOUCHERS: (state, payload) => {
    state.vouchers = payload
  },
  SET_ERROR: (state, payload) => {
    state.error = payload
  },
  REMOVE_ERROR: state => {
    state.error = null
  },
  SET_SUCCESS: (state, payload) => {
    state.success = payload
  },
  REMOVE_SUCCESS: state => {
    state.success = null
  },
  ADD_VOUCHER: (state, payload) => {
    state.vouchers.push(payload)
  },
  REMOVE_VOUCHER: (state, payload) => {
    state.vouchers.splice(state.vouchers.indexOf(payload), 1)
  },
  SET_CART_VOUCHERS: (state, payload) => {
    state.cartVouchers = payload
  },
  SET_VOUCHER_MODAL_VISIBLE: (state, payload) => {
    state.isVoucherModalVisible = Boolean(payload)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
